export const guestPurchasingGiftCard = ({
  giftCardId,
  isAuthenticated,
  isGuestCheckout,
  isWebEnableCheckoutGiftCardsAllowGuestPurchase,
}) => {
  return (
    !!giftCardId &&
    (!isAuthenticated || isGuestCheckout) &&
    isWebEnableCheckoutGiftCardsAllowGuestPurchase
  );
};

export const purchasingGiftCard = ({
  giftCardId,
  isCheckoutPurchaseGiftCardsEnabled,
  isGuestPurchasingGiftCard,
}) => {
  return (!!giftCardId || isGuestPurchasingGiftCard) && isCheckoutPurchaseGiftCardsEnabled;
};
